export enum InviteDeveloperSelectionMode {
  NewDeveloper = "newDeveloper",
  ExistingDeveloperWithoutUsers = "existingDeveloperWithoutUsers",
  ExistingDeveloperWithUsers = "existingDeveloperWithUsers",
}

export interface ExistingDeveloperOption {
  hasUsers: boolean;
  organisationUuid: string;
  value: string;
}
